import {Table} from "antd";
import React from "react";

const WaitingShipmentTable = ({
    record,
    barcodeNumber,
    selectedShipmentKeys,
    setSelectedShipmentKeys,
    parentRecord
}) => {
    const shipmentRowSelection = {
        selectedRowKeys: selectedShipmentKeys,
        preserveSelectedRowKeys: true,
        onChange: selectedKeys => {
            setSelectedShipmentKeys(selectedKeys);
        }
    };
    return (
        <Table
            dataSource={record?.shipments?.filter(shipment =>
                shipment?.externalShipmentId.toLowerCase().includes(barcodeNumber.toLowerCase())
            )}
            pagination={false}
            scroll={{x: "scroll"}}
            size="small"
            className="shipment-table"
            style={{
                background: "#fafafa",
                margin: "0 20px",
                border: "1px solid #f0f0f0"
            }}
            rowKey={shipment => {
                return `${parentRecord?.groupId}-${record?.transferId}-${shipment?._id}`;
            }}
            rowSelection={shipmentRowSelection}
            rowClassName={record => {
                if (record?.scannedCount === record?.count) return "table-row-green";
                return "table-row-red";
            }}
        >
            <Table.Column
                title="Barkod Numarası"
                dataIndex="externalShipmentId"
                key="externalShipmentId"
                ellipsis
                width={"200px"}
            />
            <Table.Column
                title="Vigo Barkod"
                dataIndex="vigoBarcodeNumber"
                key="vigoBarcodeNumber"
                ellipsis
                width={"200px"}
            />
            <Table.Column
                title="Paket Sayısı"
                dataIndex="count"
                key="count"
                ellipsis
                render={(count, record) => (
                    <span>
                        {record?.scannedCount} / {record?.count} Paket
                    </span>
                )}
                width={"200px"}
            />
            <Table.Column
                title="Müşteri Adı"
                dataIndex="receiver"
                key="receiver"
                ellipsis
                width={"200px"}
                render={receiver => <span>{receiver?.name}</span>}
            />
            <Table.Column
                title="İl"
                dataIndex="receiver"
                key="receiver"
                ellipsis
                width={"200px"}
                render={receiver => <span>{receiver?.city}</span>}
            />
            <Table.Column
                title="İlçe"
                dataIndex="receiver"
                key="receiver"
                ellipsis
                width={"200px"}
                render={receiver => <span>{receiver?.district}</span>}
            />
        </Table>
    );
};

export default WaitingShipmentTable;
